import { Paper, Box } from "@mui/material"
import { memo, useMemo, useRef } from "react";
import HorizontalScrollButtons from "../../HorizontalScrollWrapper/horizontalScrollWrapper";
import { selectBasketId, selectStrategyBuilderMode, selectTradeOrders } from "../../../selectors/strategyBuilder";
import { useSelector } from "react-redux";
import LiveStrategyInfo from "../liveStrategyInfo";
import { useCombineBasketAnalyzeAndLegOrders } from '../../../hooks/useCombineBasketAnalyzeAndLegOrders.ts'
import PnlData from '../PnlData.tsx'
import { selectPositions } from "../../../selectors/positions.ts";

export type StrategyBuilderSubheaderProps = {
    simulator : boolean
}

const StrategyBuilderSubHeader: React.FC<StrategyBuilderSubheaderProps> = ({ simulator }) => {
    const tradeOrders = useSelector(selectTradeOrders);
    const strategyBuilderMode = useSelector(selectStrategyBuilderMode);
    const { orders = [], analyzeOrders } = useCombineBasketAnalyzeAndLegOrders()
    const positions = useSelector(selectPositions)
    const basketId = useSelector(selectBasketId)
    const basketPositions = useMemo(() => positions?.filter(p => p.basketId === basketId), [positions, basketId])

    const showPnL = useMemo(() => {
        if (simulator) {
            return orders.length > 0 || (analyzeOrders?.length ?? 0) > 0;
        }
        return (tradeOrders.length > 0 || basketPositions?.length > 0) || ['analyze', 'squareOff'].includes(strategyBuilderMode);
    }, [simulator, orders, analyzeOrders, tradeOrders, strategyBuilderMode, basketPositions]);

    const containerRef = useRef<HTMLDivElement>(null)

    return (showPnL ?
        <HorizontalScrollButtons containerRef={containerRef}>
            <Paper sx={{ width: '100%', height: '64px', position: 'relative', borderRadius: 0 }}>
                <Box ref={containerRef} sx={{ display: 'flex', justifyContent: 'space-between', overflowX: 'scroll', alignItems: 'center', px: 1, pt: '0px', pb: '4px' }}>
                    { simulator ? <PnlData simulator={simulator}/> : <LiveStrategyInfo />}
                </Box>
            </Paper>
        </HorizontalScrollButtons>
        : null)
}

export default memo(StrategyBuilderSubHeader);
